// extracted by mini-css-extract-plugin
module.exports = {"articleHeadline":"ArticleHeadline-module--articleHeadline--17ZrS"};